import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getCourseAssignmentFeedQuery,
  getCourseAssignmentStateWiseCountQuery,
  getAssignmentEditDetailsQuery,
  getStudentAssignmentDetailsQuery,
  getAssignmentDetailsQuery,
  getStudentTodosQuery,
  getFamilyStudentTodosQuery,
  getTeacherClassroomReviewQuery,
  getFamilyStudentTodosFilterCountQuery,
  getAssignmentEvaluationInsightQuery,
  getOrganizationAssignmentFeedQuery,
  getCourseUserMapQuery,
  getAssignedStudentsQuery,
  getSubjectAndGenericTagByCourseQuery,
  getStudentCourseTagsQuery,
  getCourseSubjectFlatVariantsLevelQuery,
  getUnitPlanFieldsQuery,
  getCategoryScoreValuesQuery,
  getAssignmentFoldersAndPostSettingsQuery,
  getDeletedAssignmentFeedQuery,
  getAssignedStudentsAIConversationQuery,
  getAssignedStudentsForAIEvaluationQuery,
  getStudentAssignmentQuery,
  getCourseAssignmentFeedWithoutAssignedStudentQuery,
  getTeacherTasksQuery,
  getStudentTasksQuery,
  getStudentTasksFilterCountQuery,
} from "./ClassRoomQuery";
import {
  courseAssignmentFragment,
  studentAssigmentSubmissionFragment,
  studentAssignmentFragment,
  assignmentFragment,
} from "./ClassRoomFragments";

export const getCourseAssignmentFeedFromCache = ({
  courseId,
  createdBy,
  contentTypes,
  assessmentTypes,
  searchText,
  states,
  orderBy,
  orderByDirection,
  folderIds,
  studentIds,
  showUpcoming,
  unreadMessageCountFilters,
  excludedAssessmentTypes,
  first,
  isFetchUnreadConverstionAssignment,
  isFetchToReviewAssigment,
  userArchivedFilters,
  academicTermIds,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseAssignmentFeedQuery,
      variables: {
        courseId,
        createdBy,
        searchText,
        contentTypes,
        assessmentTypes,
        states,
        orderBy,
        orderByDirection,
        folderIds,
        studentIds,
        showUpcoming,
        unreadMessageCountFilters,
        excludedAssessmentTypes,
        first,
        isFetchUnreadConverstionAssignment,
        isFetchToReviewAssigment,
        userArchivedFilters,
        academicTermIds,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseAssignmentFeedWithoutAssignedStudentFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getDeletedAssignmentFeedQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getDeletedAssignmentFeedQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getFamilyStudentTodosFilterFromCache = ({ variables }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getFamilyStudentTodosFilterCountQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  return {};
};

export const getCourseAssignmentStateWiseCountFromCache = ({
  courseId,
  excludedAssessmentTypes = [],
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseAssignmentStateWiseCountQuery,
      variables: {
        courseId,
        excludedAssessmentTypes,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAssignmentFoldersAndPostSettingsFromCache = id => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssignmentFoldersAndPostSettingsQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getAssignmentEditDetailsFromCache = ({
  id,
  userArchivedFilters,
  isLinkedAssignments = false,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssignmentEditDetailsQuery,
      variables: {
        id,
        userArchivedFilters,
        isLinkedAssignments,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStudentCourseTagsFromCache = ({ id, courseIds }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentCourseTagsQuery,
      variables: { id, courseIds },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAssignmentDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssignmentDetailsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStudentAssignmentDetailsFromCache = ({
  id,
  showOnlySubmitted,
  userFilter,
  entityEventsFilter,
  userArchivedFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentAssignmentDetailsQuery,
      variables: {
        id,
        showOnlySubmitted,
        userFilter,
        entityEventsFilter,
        userArchivedFilters,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeStudentAssignmentDetailsInCache = ({
  id,
  data,
  showOnlySubmitted,
  userFilter,
  entityEventsFilter,
  userArchivedFilters,
}) => {
  try {
    client.writeFragment({
      id: `StudentAssignment:${id}`,
      fragment: studentAssignmentFragment.studentAssignmentDetails,
      fragmentName: "studentAssignmentItem",
      variables: {
        showOnlySubmitted,
        userFilter,
        entityEventsFilter,
        userArchivedFilters,
      },
      data,
    });
  } catch (e) {}
};

export const writeCourseAssignmentFeedFromCache = ({
  courseId,
  createdBy,
  contentTypes,
  assessmentTypes,
  excludedAssessmentTypes,
  searchText,
  data,
  states,
  orderBy,
  orderByDirection,
  folderIds,
  first,
  userArchivedFilters,
}) => {
  try {
    client.writeFragment({
      id: `Course:${courseId}`,
      fragment: courseAssignmentFragment.courseAssignmentFeed,
      fragmentName: "courseAssignmentItem",
      variables: {
        createdBy,
        searchText,
        contentTypes,
        assessmentTypes,
        states,
        orderBy,
        orderByDirection,
        folderIds,
        first,
        excludedAssessmentTypes,
        userArchivedFilters,
      },
      data,
    });
  } catch (e) {}
};

export const writeCourseAssignmentFeedWithoutAssignedStudentInCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
      variables,
      data,
    });
  } catch (e) {}
};

export const writeCourseAssignmentStateWiseCountInCache = ({
  courseId,
  data,
  excludedAssessmentTypes,
}) => {
  try {
    client.writeFragment({
      id: `Course:${courseId}`,
      fragment: courseAssignmentFragment.courseAssignmentStateWiseCount,
      fragmentName: "courseAssignmentItem",
      data,
      variables: {
        excludedAssessmentTypes,
      },
    });
  } catch (e) {}
};

export const writeStudentAssigmentSubmissionInCache = ({ id, data }) => {
  try {
    client.writeFragment({
      id: `StudentAssignmentSubmission:${id}`,
      fragment: studentAssigmentSubmissionFragment.studentAssigmentSubmission,
      fragmentName: "studentAssigmentSubmissionItem",
      data,
    });
  } catch (e) {}
};

export const getStudentTodosFeedFromCache = input => {
  let queryData;
  try {
    queryData = client.readQuery({
      query: getStudentTodosQuery,
      variables: { ...input },
    });
  } catch (e) {
    return {};
  }

  return queryData ? _.get(queryData, "node", {}) : {};
};

export const getFamilyStudentTodosFeedFromCache = input => {
  let queryData;
  try {
    queryData = client.readQuery({
      query: getFamilyStudentTodosQuery,
      variables: { ...input },
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getTeacherClassroomReviewFromCache = input => {
  let queryData;
  try {
    queryData = client.readQuery({
      query: getTeacherClassroomReviewQuery,
      variables: { ...input },
    });
  } catch (e) {
    return {};
  }

  return queryData ? _.get(queryData, "node", {}) : {};
};

export const getOrganizationAssignmentFeedFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getOrganizationAssignmentFeedQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getAssignmentEvaluationInsightFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAssignmentEvaluationInsightQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getAssignmentFeedWithoutAssignedStudentsItemFromCache = ({
  id,
  variables,
}) => {
  try {
    const fragmentData = client.readFragment({
      id: `Assignment:${id}`,
      fragment: assignmentFragment.assignmentFeedWithoutAssignedStudents,
      fragmentName: "assignmentItem",
      variables,
    });
    return fragmentData;
  } catch (e) {
    return {};
  }
};

export const writeAssignmentFeedWithoutAssignedStudentsItemToCache = ({
  id,
  data,
  userArchivedFilters,
}) => {
  try {
    client.writeFragment({
      id: `Assignment:${id}`,
      fragment: assignmentFragment.assignmentFeedWithoutAssignedStudents,
      fragmentName: "assignmentItem",
      variables: { userArchivedFilters },
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const getCourseUserMapFromCache = args => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseUserMapQuery,
      variables: args,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAssignedStudentsFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssignedStudentsQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectAndGenericTagByCourseFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectAndGenericTagByCourseQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", []);
  else return {};
};

export const getSubjectFlatVariantsLevelFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getCourseSubjectFlatVariantsLevelQuery,
      variables,
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getUnitPlanFieldsFromCache = ({ id }) => {
  try {
    const queryData = client.readQuery({
      query: getUnitPlanFieldsQuery,
      variables: { id },
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
export const getCategoryScoreValuesFromCache = ({ id }) => {
  try {
    const queryData = client.readQuery({
      query: getCategoryScoreValuesQuery,
      variables: { id },
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getUpdateAssignmentDetailsFromCache = ({
  id,
  userArchivedFilters,
  isLinkedAssignments = false,
}) => {
  try {
    return client.readFragment({
      id: `Assignment:${id}`,
      fragment: assignmentFragment.assignmentEdit,
      fragmentName: "assignmentItem",
      variables: {
        userArchivedFilters,
        isLinkedAssignments,
      },
    });
  } catch (e) {
    return {};
  }
};

export const writeUpdateAssignmentDetailsInCache = ({
  id,
  data,
  userArchivedFilters,
  isLinkedAssignments = false,
}) => {
  try {
    return client.writeFragment({
      id: `Assignment:${id}`,
      fragment: assignmentFragment.assignmentEdit,
      fragmentName: "assignmentItem",
      data,
      variables: {
        userArchivedFilters,
        isLinkedAssignments,
      },
    });
  } catch (e) {
    return {};
  }
};

export const getAssignedStudentsAIConversation = async variables => {
  try {
    const response = await client.query({
      query: getAssignedStudentsAIConversationQuery,
      variables,
      fetchPolicy: "network-only",
    });

    return _.get(response, "data.node", {});
  } catch (error) {
    return {};
  }
};

export const getAssignedStudentsForAIEvaluation = async variables => {
  try {
    const response = await client.query({
      query: getAssignedStudentsForAIEvaluationQuery,
      variables,
      fetchPolicy: "network-only",
    });

    return _.get(response, "data.node", {});
  } catch (error) {
    return {};
  }
};

export const getStudentAssignmentSubmissionFromCache = ({ id, userFilter }) => {
  try {
    return client.readFragment({
      id: `StudentAssignmentSubmission:${id}`,
      variables: {
        userFilter,
      },
      fragment:
        studentAssigmentSubmissionFragment.studentAssigmentSubmissionWithEvaluation,
      fragmentName: "studentAssigmentSubmissionItem",
    });
  } catch (e) {
    return {};
  }
};

export const writeStudentAssignmentSubmissionInCache = ({
  id,
  userFilter,
  data,
}) => {
  try {
    client.writeFragment({
      id: `StudentAssignmentSubmission:${id}`,
      variables: {
        userFilter,
      },
      fragment:
        studentAssigmentSubmissionFragment.studentAssigmentSubmissionWithEvaluation,
      fragmentName: "studentAssigmentSubmissionItem",
      data,
    });
  } catch (e) {
    return;
  }
};

export const getStudentAssignmentFromCache = ({
  id,
  userFilter,
  entityEventsFilter,
  userArchivedFilters,
}) => {
  try {
    const queryData = client.readQuery({
      query: getStudentAssignmentQuery,
      variables: {
        id,
        userFilter,
        entityEventsFilter,
        userArchivedFilters,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeStudentAssignmentInCache = ({
  id,
  data,
  userFilter,
  entityEventsFilter,
  userArchivedFilters,
}) => {
  try {
    client.writeFragment({
      id: `StudentAssignment:${id}`,
      fragment: studentAssignmentFragment.studentAssignment,
      fragmentName: "studentAssignmentItem",
      variables: {
        userFilter,
        entityEventsFilter,
        userArchivedFilters,
      },
      data,
    });
  } catch (e) {}
};

export const getTeacherTasksQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getTeacherTasksQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeTeacherTasksQueryInCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getTeacherTasksQuery,
      variables,
      data,
    });
  } catch (e) {}
};

export const getStudentTasksFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentTasksQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentTasksFilterCountFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentTasksFilterCountQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
